﻿(function() {
  "use strict";

  angular
    .module("app")
    .controller("SignInController", SignInController);

  SignInController.$inject = ["$rootScope", "$state"]

  function SignInController($rootScope, $state) {
    var vm = this

    const onSignIn = () => {
      if ($rootScope.loginReturnState) {
        $state.go($rootScope.loginReturnState.name(), $rootScope.loginReturnState.params())
        $rootScope.loginReturnState = undefined
      } else {
        $state.go('root.home')
      }
    }
    vm.onSignIn = onSignIn
  }
})();
